import { render, staticRenderFns } from "./MaterialSelect2.vue.js?vue&type=template&id=75dc1fb2&scoped=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSelect2.vue?vue&type=template&id=75dc1fb2&scoped=true"
import script from "./MaterialSelect2.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSelect2.vue?vue&type=script&lang=js"
export * from "./MaterialSelect2.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./MaterialSelect2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dc1fb2",
  null
  
)

export default component.exports